import { render, staticRenderFns } from "./MostViewedItems.vue?vue&type=template&id=3a149fc4&"
import script from "./MostViewedItems.vue?vue&type=script&lang=js&"
export * from "./MostViewedItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports